import type { LocalizationMap } from './Localization/Localization';
// ------------------------------------------------------ 
export const enum SelectUILabelKey {
    SelectAll = 'select_all',
    Placeholder = 'placeholder',
    NewOption = 'new_option',
    Add = 'add',
    Clear = 'clear'
}
// ------------------------------------------------------
export const SelectLocalizationTextMapKey: string = "Primitive_Select";
export const SELECT_ALL_LABEL = 'Select all';
// ------------------------------------------------------ 
export function GetSelectLocalizationDictionary(): LocalizationMap {
    return {
        [SelectUILabelKey.SelectAll]: SELECT_ALL_LABEL,
        [SelectUILabelKey.Placeholder]: "Select...",
        [SelectUILabelKey.NewOption]: "New option",
        [SelectUILabelKey.Add]: "Add option",
        [SelectUILabelKey.Clear]: "Clear selection(s)"
    };
}
// ------------------------------------------------------